function upsertMeta(name, content, attr = "name") {
  if (!name) return;
  const selector = `meta[${attr}="${name}"]`;
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("meta");
    node.setAttribute(attr, name);
    node.setAttribute("data-seo-managed", "1");
    document.head.appendChild(node);
  }
  node.setAttribute("content", String(content || ""));
}

function upsertLink(rel, href) {
  if (!rel) return;
  let node = document.head.querySelector(`link[rel="${rel}"]`);
  if (!node) {
    node = document.createElement("link");
    node.setAttribute("rel", rel);
    node.setAttribute("data-seo-managed", "1");
    document.head.appendChild(node);
  }
  node.setAttribute("href", href || "");
}

function replaceJsonLd(jsonLd) {
  const existing = document.head.querySelectorAll("script[type=\"application/ld+json\"][data-seo-jsonld=\"1\"]");
  existing.forEach((node) => node.remove());

  const entries = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  entries.forEach((entry) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-seo-jsonld", "1");
    script.textContent = JSON.stringify(entry);
    document.head.appendChild(script);
  });
}

export function applySeoToDocument(seoResult) {
  if (!seoResult || typeof document === "undefined") return;

  document.title = seoResult.title || "Inssa";
  upsertMeta("description", seoResult.description);
  upsertMeta("robots", seoResult.robots);
  upsertLink("canonical", seoResult.canonical);

  upsertMeta("og:title", seoResult.og?.title, "property");
  upsertMeta("og:description", seoResult.og?.description, "property");
  upsertMeta("og:type", seoResult.og?.type, "property");
  upsertMeta("og:url", seoResult.og?.url, "property");
  upsertMeta("og:image", seoResult.og?.image, "property");
  upsertMeta("og:site_name", seoResult.og?.siteName, "property");
  upsertMeta("og:locale", seoResult.og?.locale, "property");

  upsertMeta("twitter:card", seoResult.twitter?.card);
  upsertMeta("twitter:site", seoResult.twitter?.site);
  upsertMeta("twitter:title", seoResult.twitter?.title);
  upsertMeta("twitter:description", seoResult.twitter?.description);
  upsertMeta("twitter:image", seoResult.twitter?.image);

  replaceJsonLd(seoResult.jsonLd);
}

export default applySeoToDocument;

